import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW4801Model } from '../kymw4801.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * Pコード商品情報取得サービス
 * @export GetPcodeGoodsInfoService
 * @class GetPcodeGoodsInfoService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetPcodeGoodsInfoService extends PlessJsonResponderSub<any> {
  private model: KYMW4801Model;
  private successFunc: Function;
  private vo: any;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetPcodeGoodsInfoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        PCode: this.vo.pCode,
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW4801Model} model モデルクラス
   * @param {any} vo 
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetPcodeGoodsInfoService
   */
  execute(model: KYMW4801Model, vo: any, successFunc: Function): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getPcodeGoodsInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetPcodeGoodsInfoService
   */
  success(data: any): void {
    if (data !== null) {
      this.model.addCrossGoodsInfoData(data);
    } else {
      // dataがnullで返ってくる場合リセット
      this.model.pcodeGoodsInfoList = [];
    }
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }

  /**
   * API通信失敗時の処理
   *
   * @param {string} status エラーステータス
   * @param {*} result エラー結果
   * @memberof GetPcodeGoodsInfoService
   */
  exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
    this.model.kymw4801Component.exit();
  }
}
